export const MOBILE_NUMBER_EMPTY = 'Field is required!'
export const MOBILE_NUMBER_VALIDATION = 'Not a valid Mobile Number'

export const NAME_FIELD_EMPTY = 'Field is required!'
export const NAME_FIELD_VALIDATION = 'Not a valid Name'

export const EMAIL_FIELD_EMPTY = 'Field is required!'
export const EMAIL_FIELD_VALIDATION = 'Not a valid Email'

export const ID_FIELD_VALIDATION = 'Invalid ZET ID. Please Re-enter'
export const GENERIC_ALPHABET_FIELD_VALIDATION = 'Not a valid Input'

export const FIELD_EMPTY = 'Field is required!'
export const SUBDOMAIN_VALIDATION = 'Not a valid Subdomain'

export const BUSINESS_NAME_VALIDATION = 'Not a valid Business Name'
export const SHORT_INTRODUCTION_VALIDATION = 'Not a valid short introduction'
